export default __webpack_public_path__ + "static/media/YAS0010.34I-27179_-16416_0.fd1681cf.jpg";